export default __webpack_public_path__ + "static/media/logoUcropitDark.25d8c998.svg";